<div class="container">
    <app-section-header title="{{ title }}" [actionsTemplate]="actionsTemplate" [iconName]="'goBack'">
        <ng-template #actionsTemplate>
            <div class="actions">
                <button class="secondary-btn" (click)="cancel()">Cancel</button>
                <button class="primary-btn" (click)="saveCompany()">{{ buttonLabel }}</button>
            </div>
        </ng-template>
    </app-section-header>

    <div class="cardsContainer">
        <app-companies-single-overview
            [company]="company"
            [isReadOnly]="false"
            #overview
        ></app-companies-single-overview>
    </div>
</div>
